import { render, staticRenderFns } from "./DialogDashboard.vue?vue&type=template&id=77259e79"
import script from "./DialogDashboard.vue?vue&type=script&lang=js"
export * from "./DialogDashboard.vue?vue&type=script&lang=js"
import style0 from "./DialogDashboard.vue?vue&type=style&index=0&id=77259e79&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports